import script from "./DetailedAudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailedAudioPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./DetailedAudioPlayer.vue?vue&type=style&index=0&id=115f9ea6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115f9ea6"]])

export default __exports__